var _jsxFileName = "/repo/packages/ippm/src/utils/experimentContext.js",
  _this = this;
import React, { useContext, createContext, useMemo } from 'react';
import PropTypes from 'prop-types';
var ExperimentContext = /*#__PURE__*/createContext({
  experiments: {},
  config: {}
});

/*
  Experiments can come from consuming app or we can call for assignments from here.
  We want to avoid multiple calls to ExpSvc if possible so if the consuming app has
  context it can send it down. Otherwise we can configure experiments here if they
  are only needed within IPPM.
  TODO: provide example of calling experimentsvc directly
*/
// ExperimentsContext.propTypes = {
//   experiments: PropTypes.objectOf(PropTypes.string),
//   children: PropTypes.node,
// };

// if this is called from another component use ExperimentsProvider.config - it maps to this
function getExperimentConfig(experiments) {
  return {
    // IG-1374
    IG1374_LIMIT_INDIVIDUAL_PLANS: experiments.ig_1374_limit_individual_plans_customization === 'ig_1374_limit_individual_plans_customization_treatment',
    // IG-1453
    IG1453_REMOVE_TEAM_PREMIER: experiments.ig_1453_remove_team_premier === 'ig_1453_remove_team_premier_treatment',
    // IG-2072
    IG2072_EDU_VISIBILITY: experiments.ig_2072_edu_visibility === 'ig_2072_edu_visibility_treatment',
    // GROW-1898
    GROW_1898_STARTER_ANNUAL_V2: experiments.grow_starter_annual_price_test === 'grow_starter_annual_price_test_treatment1' || experiments.grow_starter_annual_price_test === 'grow_starter_annual_price_test_treatment2',
    // IG-2101
    IG_2101_UPSELL_PAID_COLLECT: experiments.ig_2101_upsell_paid_collect === 'ig_2101_upsell_paid_collect_treatment',
    // IG-2151
    IG_2151_ADVANTAGE_HIDE_FOOTER: experiments.ig_2151_advantage_hide_footer === 'ig_2151_advantage_hide_footer_treatment',
    // Experiment for testing
    TEST_EXPERIMENT_FIXTURE: experiments.test_experiment_fixture === 'test_experiment_fixture_treatment'
  };
}
export var ExperimentProvider = function ExperimentProvider(_ref) {
  var experiments = _ref.experiments,
    children = _ref.children;
  var contextValue = useMemo(function () {
    return {
      experiments: experiments,
      config: getExperimentConfig(experiments)
    };
  }, [experiments]);
  return /*#__PURE__*/React.createElement(ExperimentContext.Provider, {
    value: contextValue,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 65,
      columnNumber: 5
    }
  }, children);
};
ExperimentProvider.propTypes = {
  experiments: PropTypes.objectOf(PropTypes.string).isRequired,
  children: PropTypes.node.isRequired
};
export function usePassedExperimentContext() {
  return useContext(ExperimentContext).experiments;
}
export function useConfiguredExperimentContext() {
  return useContext(ExperimentContext).config;
}